/**
 * Rich-text fra MIRA (kursusbeskrivelser) → sikker HTML.
 *
 * Allowlist-sanitizer uden afhængigheder: kun simple teksttags bevares, alle
 * attributter fjernes (undtagen http(s)/mailto-href på links), og ukendte tags
 * pakkes ud til deres tekst. script/style/iframe o.l. fjernes helt.
 */

const ALLOWED = new Set(['p', 'br', 'strong', 'b', 'em', 'i', 'u', 'ul', 'ol', 'li', 'a', 'h3', 'h4']);
const DROP = new Set(['script', 'style', 'iframe', 'object', 'embed', 'img', 'svg', 'template', 'noscript']);
const SAFE_HREF = /^(https?:|mailto:)/i;

function escapeText(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function escapeAttr(s: string): string {
  return escapeText(s).replace(/"/g, '&quot;');
}

function walk(node: Node): string {
  if (node.nodeType === Node.TEXT_NODE) return escapeText(node.textContent ?? '');
  if (node.nodeType !== Node.ELEMENT_NODE) return '';
  const el = node as Element;
  const tag = el.tagName.toLowerCase();
  if (DROP.has(tag)) return '';
  const inner = Array.from(el.childNodes).map(walk).join('');
  if (!ALLOWED.has(tag)) return inner;
  if (tag === 'br') return '<br>';
  if (tag === 'a') {
    const href = el.getAttribute('href')?.trim() ?? '';
    return SAFE_HREF.test(href)
      ? `<a href="${escapeAttr(href)}" target="_blank" rel="noopener noreferrer">${inner}</a>`
      : `<a>${inner}</a>`;
  }
  return `<${tag}>${inner}</${tag}>`;
}

export function sanitizeRichText(html: string): string {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return Array.from(doc.body.childNodes).map(walk).join('');
}
